import { destroyCookie, parseCookies } from "nookies";
import { api } from "../api";
import { UserAuthMe } from "./user";

export const authService = {
  async login(username: string, password: string): Promise<UserAuthMe | null> {
    try {
      const response = await api.post<UserAuthMe>("/auth/signin", {
        username,
        password,
      });

      console.log(response.data);

      if (response.data.token) {
        sessionStorage.setItem("user", JSON.stringify(response.data));

        return response.data;
      }

      return null;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  checkLogin(): UserAuthMe | null {
    const v = sessionStorage.getItem("user");
    if (!v) return null;
    const user = JSON.parse(v) as UserAuthMe;
    return user;
  },

  logout() {
    destroyCookie(null, "authToken");
    sessionStorage.removeItem("user");
  },

  getToken(): string | null {
    const cookies = parseCookies();
    return cookies.authToken || null;
  },
};
